import { timer } from "rxjs";
import {
  map,
  /////////////////
  catchError,
  delay,
  delayWhen,
  dematerialize,
  finalize,
  materialize,
  observeOn,
  repeat,
  retry,
  subscribeOn,
  tap,
  timeInterval,
  timeout,
  timestamp,
  toArray
} from "rxjs/operators";

export const utilityExamples = {
  delay: {
    label: "delay(20)",
    inputs: [
      [
        { t: 10, c: "1" },
        { t: 20, c: "2" },
        { t: 70, c: "1" }
      ]
    ],
    apply: (inputs, scheduler) =>
      inputs[0].pipe(
        map((x) => x.content),
        delay(20, scheduler)
      )
  },

  delayWhen: {
    label: "delayWhen(x => timer(20 * x))",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 10, c: 2 },
        { t: 20, c: 1 }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        delayWhen(({ content }) => timer(content * 20, 1000, scheduler))
      );
    }
  },

  finalize: {
    label: "finalize",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 10, c: 2 },
        { t: 20, c: 3 }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(finalize(() => console.log("finalize")));
    }
  },

  tap: {
    label: "tap",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 10, c: 2 },
        { t: 20, c: 1 }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(tap((x) => x.content));
    }
  },

  timeInterval: {
    label: "timeInterval",
    inputs: [
      [
        { t: 10, c: "A" },
        { t: 20, c: "B" },
        { t: 60, c: "C" },
        { t: 90, c: "D" }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        timeInterval(scheduler),
        map(({ value, interval }) => parseInt(interval))
      );
    }
  },

  timestamp: {
    label: "timestamp",
    inputs: [
      [
        { t: 10, c: "A" },
        { t: 20, c: "B" },
        { t: 60, c: "C" },
        { t: 90, c: "D" }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        timestamp(scheduler),
        map(({ value, timestamp }) => parseInt(timestamp))
      );
    }
  },

  toArray: {
    label: "toArray",
    inputs: [[{ t: 10, c: "A" }, { t: 20, c: "B" }, { t: 60, c: "C" }, 70]],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        map((x) => x.content),
        toArray(),
        map((arr) => `[${arr}]`)
      );
    }
  }
};
